export default __webpack_public_path__ + "static/media/downbutton.788538c5.png";